import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.scss";
import StoreProvider from "./store/StoreContext";
import { LOCAL_SESSION, LOCAL_TOKEN } from "./constants/local-entity";

// Timeout global: 30 segundos para peticiones propias
axios.defaults.timeout = 30000;

// Interceptor global: agrega headers de audit + Bearer token JWT
// Para URLs externas (Power Automate, etc.) se extiende el timeout y no se envían headers internos
axios.interceptors.request.use((config) => {
  const url = config.url || "";
  const isExternal = url.includes("powerplatform.com") || url.includes("logic.azure.com");
  if (isExternal) {
    config.timeout = 120000; // 2 min para Power Automate
    return config; // No agregar headers internos a servicios externos
  }
  try {
    const encrypted = localStorage.getItem(LOCAL_SESSION);
    if (encrypted) {
      const session = JSON.parse(atob(encrypted));
      if (session?.username) {
        config.headers["x-user-email"] = session.username;
      }
      if (session?.profile) {
        config.headers["x-user-profile"] = String(session.profile);
      }
    }
  } catch (_) {}

  // Fase 2: enviar JWT si existe
  try {
    const token = localStorage.getItem(LOCAL_TOKEN);
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
  } catch (_) {}

  return config;
});

// Interceptor response: capturar 401 para mostrar re-login (preparado para Fase 3)
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // No redirigir ni sacar al usuario - emitir evento para mostrar modal de reauth
      window.dispatchEvent(new CustomEvent("auth:token-expired"));
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <StoreProvider>
      <App />
    </StoreProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
